// extracted by mini-css-extract-plugin
export default {"root":"PastAuditAnalysisHistoryPage_root__cAvJi"};